module.exports = __webpack_public_path__ + "img/kh.a1737437.svg";